import { Component, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { Router } from '@angular/router';
import { RequestService } from 'src/app/services/request.service';
import { SnackService } from 'src/app/services/snack.service';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';

@Component({
  selector: 'app-request-account',
  templateUrl: './request-account.component.html',
  styleUrls: ['./request-account.component.scss']
})
export class RequestAccountComponent extends SubscriptionBasedComponent
  implements OnInit {
  requestAccountForm: UntypedFormGroup;

  constructor(
    private fb: UntypedFormBuilder,
    private requestService: RequestService,
    private snackService: SnackService,
    private router: Router
  ) {
    super();
    this.requestAccountForm = this.fb.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      mobilePhoneNumber: ['', Validators.required],
      companyName: ['', Validators.required]
    });
  }

  ngOnInit(): void {}

  submit(): void {
    if (!this.requestAccountForm.valid) {
      this.snackService.showError('Gelieve alle velden correct in te vullen');
      return;
    }
    this.addSubscription(
      this.requestService.post(
        this.requestAccountForm.value,
        '/auth/requestAccount'
      ),
      res => {
        this.snackService.showSuccess(
          'Account succesvol aangevraagd, wij controleren gegevens en sturen link door voor aanmaak van passwoord'
        );
        this.router.navigateByUrl('/login');
      }
    );
  }
}
